export const money = (cents) => cents == null ? "Needs review" : new Intl.NumberFormat("en-ZA", { style: "currency", currency: "ZAR" }).format(cents / 100);
export const monthLabel = (month) => new Intl.DateTimeFormat("en-ZA", { timeZone: "Africa/Johannesburg", month: "long", year: "numeric" }).format(new Date(`${month}-01T12:00:00+02:00`));
export const dateLabel = (value) => value ? new Intl.DateTimeFormat("en-ZA", { timeZone: "Africa/Johannesburg", dateStyle: "medium" }).format(new Date(value.length === 10 ? `${value}T12:00:00+02:00` : value)) : "—";
export function nextBillDate(month) {
  const [year, number] = month.split("-").map(Number);
  return new Date(Date.UTC(year, number, 1, 12)).toISOString().slice(0, 10);
}
export function accountSummary(org) {
  const value = org.billing?.invoiceSummary;
  const validCents = (amount) => Number.isSafeInteger(amount) && amount >= 0;
  if (!value || value.orgId !== org.id || value.currency !== "ZAR" || !validCents(value.totalCents) || !validCents(value.creditCents)) return null;
  if (!["neo", "mc", "bundle"].every((layer) => validCents(value.balances?.[layer]))) return null;
  if (value.totalCents !== value.balances.neo + value.balances.mc + value.balances.bundle) return null;
  return value;
}
export const needsReview = (preview) => preview && (preview.sourceComplete === false || preview.totalCents == null);
export function usageCents(preview, filter = "all") {
  if (!preview || needsReview(preview)) return null;
  if (filter === "all") return preview.totalCents;
  // An enterprise bill is indivisible; individual services are included.
  if (preview.pricingMode === "enterprise_bundle") return null;
  return preview[filter].amountCents;
}
export function unpaidCents(summary, filter = "all") {
  if (!summary) return null;
  return filter === "all" ? summary.totalCents : summary.balances[filter] + summary.balances.bundle;
}
